export enum HelpTypeEnum {
  Tooltip = 0,
  Walkthrough = 1,
}
